import React, { useContext } from "react";
/// React router dom
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";
import logo from "../../../images/favicon-192x192.png";


const NavHader = () => {
	const logoSize = {w: 50, h: 50};
	const toggle = false;
	const { navigationHader, background } = useContext(
		ThemeContext
	);
	return (
		<div className="nav-header">
			<Link to="/dashboard" className="brand-logo">
				{background.value === "dark" || navigationHader !== "color_1" ? (
					<>
						<img className="nav-header-logo" src={logo} width={logoSize.w} height={logoSize.h} alt="logo"></img>
					</>
				) : (
					<>
						<img className="nav-header-logo" src={logo} width={logoSize.w} height={logoSize.h} alt="logo"></img>
					</>
				)}
			</Link>

			<div
				className="nav-control"
				onClick={() => {
					//   setToggle(!toggle);
					//   openMenuToggle();
				}}
			>
				<div className={`hamburger ${toggle ? "is-active" : ""}`}>
					<span className="line"></span>
					<span className="line"></span>
					<span className="line"></span>
				</div>
			</div>
		</div>
	);
};

export default NavHader;
